import { Outlet, Route, Routes } from 'react-router-dom'
import { PageTitle } from '../../../../_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'
import { EspecialidadeListWrapper } from './especialidades-list/EspecialidadeList'

const EspecialidadePage = () => {
  const { t } = useT()
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path=''
          element={
            <>
              <PageTitle description={t('pagina.especialidade.descricao')}>
                {t('especialidade.plural')}
              </PageTitle>
              <EspecialidadeListWrapper />
            </>
          }
        />
      </Route>
    </Routes>
  )
}

export default EspecialidadePage
